import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import ElementoEntidadModal from '../ElementoEntidadModal';

const ElementoEntidadGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idElemento: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      list: [],
      listEntities: []
  });

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
        const list = props.data.list.filter(x => x.state !== 'r');
        return {...prevState,
            idElemento: props.data.idElemento,
            list: list,
            listEntities: props.data.listEntities
        };
    });
  }
  useEffect(mount, [props.data]);

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                    <div onClick={ (event) => handleClickElementoEntidadAdd() } className="link">
                                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                                    </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                    {!props.disabled && (
                                    <div onClick={ (event) => handleClickElementoEntidadRemove(data.value) } className="link">
                                        <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                    </div>
                                    )}
                              </div>

  const getDescTipoVinculo = (entidad) => {
    const row = state.listEntities.find(f => f.key === entidad);
    return (row) ? row.value : '';
  }

  const getDescVinculo = (idEntidad) => {
    const entidad = state.listEntities.find(f => f.children.find(c => c.key === idEntidad));
    const row = (entidad) ? entidad.children.find(c => c.key === idEntidad) : null;
    return (row) ? row.value : '';
  }

  const tableColumns = [
    { Header: 'Tipo vínculo', Cell: (props) => getDescTipoVinculo(props.value), accessor: 'entidad', width: '30%' },
    { Header: 'Vínculo', Cell: (props) => getDescVinculo(props.value), accessor: 'idEntidad', width: '60%' },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];

  //handles
  const handleClickElementoEntidadAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idElemento: state.idElemento,
        entidad: '',
        idEntidad: 0
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    dispatch( sequenceActionNext() );
  }
  const handleClickElementoEntidadRemove = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  }

  //funciones
  function RemoveElementoEntidad(row) {
    row.state = 'r';
    props.onChange('ElementoEntidad', row);
  }

  function UpdateElementoEntidad(row) {

    if (state.list.filter(f => f.entidad === row.entidad).map(x => x.idEntidad).includes(row.idEntidad)) {
      ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'El vínculo ya fue utilizado anteriormente');
      return;
    }
    row.state = 'a';
    props.onChange('ElementoEntidad', row);
  }

  return (
  <>

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
                setState(prevState => {
                    return {...prevState, showMessage: false, rowForm: null};
                });
            }}
            onConfirm={() => {
                const row = CloneObject(state.rowForm);
                setState(prevState => {
                    return {...prevState, showMessage: false, rowForm: null};
                });
                RemoveElementoEntidad(row);
            }}
        />
    }

    {state.showForm && 
        <ElementoEntidadModal
            data={{
              entity: state.rowForm,
              listEntities: state.listEntities
            }}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateElementoEntidad(row);
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase m-top-n25'}
        columns={tableColumns}
        data={state.list}
    />

  </>
  );
}

ElementoEntidadGrid.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onChange: func.isRequired
};

ElementoEntidadGrid.defaultProps = {
    disabled: false
  };

export default ElementoEntidadGrid;